import React from 'react';
function Main3DPage() {
    return ( <>
        MainPage
        ùlkrngùônù^p
    </> );
}

export default Main3DPage;